<template>
    <div>
        <div class="sub-header-container">
            <div class="sub-header-content" style="justify-content: center;">
                <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
                    <div class="page-title" style="text-align: center;">If you have feedback or find a bug, please write it here. We are humans so we will fix it as soon as possible. 😄 Thanks, we appreciate it!</div>
                </div>
             </div>
        </div>

        <div class="page-container">
            <div style="display: flex; justify-content: center;">
                <div class="register-container">
                    <form style="margin: 1em 0 2m 0;">
                        <div style="margin-bottom: 20px;">
                            <p style="margin-bottom: 0px;">Email adress*</p>
                            <input class="input-add" style="width: 90%;" placeholder="Enter your email" ref="email" v-model="email" @click="select($refs.email, email)" type="text" @keyup.enter="select($refs.feedback, feedback)">
                        </div>

                        <div style="margin-bottom: 20px;">
                            <p style="margin-bottom: 0px;">Your message*</p>
                            <textarea class="input-add" style="width: 90%; height:200px;" placeholder="Write your feedback or message here..." @click="select($refs.feedback, feedback)" ref="feedback" v-model="feedback"></textarea>
                        </div>

                        <button class="primary-button" style="width: 100%;" @click="createFeedback()" type="button">Send</button>

                        <p class="p-error" v-if="errors.showEmailError">⚠️ Check your email</p>
                        <p class="p-error" v-if="errors.showFeedbackError">⚠️ Missing feedback</p>
                    </form>
                    <Toast ref="toast"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Toast from '@/components/Toast'

import firebase from '@/firebase'
import * as validator from 'email-validator'

export default {
    components: {
        Toast,
    },

    data() {
        return {
            email: '',
            feedback: '',
            errors: {
                showEmailError: false,
                showFeedbackError: false,
            },
        }
    },

    methods: {
        select(ref, model){
            ref.focus()
            ref.setSelectionRange(0, model.length)
        },

        createFeedback() {
            if(!this.validate()){
                return
            }

            const now = firebase.Timestamp.fromDate(new Date())
            firebase.firestore.collection('feedback').doc()
            .set({
                email: this.email,
                feedback: this.feedback,
                createdAt: now,
            })
                .then(() => {
                    this.email = ''
                    this.feedback = ''

                    this.$refs.toast.show('Thanks for your feedback!')
                })
                .catch(e => console.error(e))
        },

        validate() {
            this.errors.showEmailError = false
            this.errors.showFeedbackError = false

            let isError = false
            if(!validator.validate(this.email)){
                this.errors.showEmailError = true
                isError = true
            }

            if(this.feedback.trim() === ''){
                this.errors.showFeedbackError = true
                isError = true
            }

            return !isError
        },
    },
}
</script>

<style>

.page-container{
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .page-container{
  padding: 0 0.5rem;
  }
}
</style>